import type { FC } from 'react';

import { Typography } from '@mui/material';

import type { Change } from 'diff';
import { diffLines, diffWords } from 'diff';

export interface DiffTextProps {
  keyPrefix: string;
  oldText: string;
  newText: string;
  diffType: TextDiffType;
}

export type TextDiffType = 'words' | 'characters' | 'lines' | undefined;

export const DiffText: FC<DiffTextProps> = ({ oldText, newText, diffType, keyPrefix }) => {
  let groups = [] as Change[];

  if (diffType === 'lines') groups = diffLines(oldText, newText);
  if (diffType === 'words' || diffType === undefined) groups = diffWords(oldText, newText);

  const mappedNodes = groups.map((group, index) => {
    const { value, added, removed } = group;

    const key = `${keyPrefix}-${index}`;

    return (
      <Typography
        component='span'
        key={key}
        variant='body2'
        sx={
          added
            ? {
                color: (theme) => theme.palette.colors.cobalt[500],
                backgroundColor: '#transparent'
              }
            : removed
              ? {
                  color: (theme) => theme.palette.error.main,
                  backgroundColor: 'transparent',
                  textDecoration: 'line-through'
                }
              : undefined
        }
      >{` ${value}`}</Typography>
    );
  });

  return <div>{mappedNodes}</div>;
};
